export default {
    name: 'int3Tree',
    fullName: 'int3Tree',
    companyName: "int3Tree",
    url: 'https://uat.int3mall.com',
    color: '#0871A1',
    meta_title: 'int3Tree',
    meta_description: '',
    meta_keyword: '',
    author: {
        name: "Ant Internet Shd Bhd",
        url: "https://ant-internet.com/",
        registration_number: "1199944-V",
    }
};
